import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'helpers/GlobalHelper';
import Style from './Menu.module.scss';

const Menu = ({
  hasFavorites,
  firstName,
  menu,
  toggleAccountMain,
  toggleChangePassword,
  toggleEditAccount,
  toggleManageFavorites,
  toggleParentalControls,
  toggleSignOut,
}) => {
  const { profileLogout_logoutButton: signoutLabel } = window.Language;
  const MANAGE_FAVORITES = 'manageFavorites';
  const menus = menu.map(item => {
    const { id } = item;
    let { label } = item;
    let clickEvent = null;
    switch (id) {
      case 'eProfile':
        clickEvent = () => {
          toggleEditAccount();
          toggleAccountMain();
        };
        break;
      case 'changePassword':
        clickEvent = () => {
          toggleChangePassword();
          toggleAccountMain();
        };
        break;
      case MANAGE_FAVORITES:
        clickEvent = () => {
          toggleManageFavorites();
          toggleAccountMain();
        };
        break;
      case 'signOut':
        clickEvent = () => {
          toggleSignOut();
          toggleAccountMain();
        };
        label = (
          <div className={Style.mobileSplit}>
            <span>{`${firstName}'s account`}</span>
            <span>{signoutLabel}</span>
          </div>
        );
        break;
      case 'parentalControls':
        clickEvent = () => {
          toggleParentalControls();
          toggleAccountMain();
        };
        break;
      default:
        break;
    }

    if (id === MANAGE_FAVORITES && !hasFavorites) {
      return null;
    }

    return (
      <button key={`account-menu-${id}`} onClick={clickEvent} className={Style.accountListItem}>
        {label}
      </button>
    );
  });
  return <div className={Style.accountContainer}>{menus}</div>;
};

export default Menu;

Menu.defaultProps = {
  firstName: '',
  hasFavorites: null,
  menu: [],
  toggleAccountMain: noop,
  toggleChangePassword: noop,
  toggleEditAccount: noop,
  toggleManageFavorites: noop,
  toggleParentalControls: noop,
  toggleSignOut: noop,
};

Menu.propTypes = {
  firstName: PropTypes.string,
  hasFavorites: PropTypes.bool,
  menu: PropTypes.arrayOf(PropTypes.shape({})),
  toggleAccountMain: PropTypes.func,
  toggleChangePassword: PropTypes.func,
  toggleEditAccount: PropTypes.func,
  toggleManageFavorites: PropTypes.func,
  toggleParentalControls: PropTypes.func,
  toggleSignOut: PropTypes.func,
};
